(() => {
  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.head = this.querySelector(".dropdown-head--click");
      this.content = this.querySelector(".dropdown-content--click");
      this.options = this.querySelectorAll(".dropdown-item");
      this.overlay = this.querySelector(".dropdown-overlay");
    }

    connectedCallback() {
      this.head.addEventListener("click", () => {
        if (this.head.classList.contains("isActive")) {
          this.closeDrop();
        } else {
          this.openDrop();
        }
      });

      this.options.forEach((option) => {
        option.addEventListener("click", () => {
          this.closeDrop();
        });
      });

      this.overlay.addEventListener("click", () => {
        this.closeDrop();
      });
    }

    closeDrop() {
      this.content.classList.remove("isActive");
      this.head.classList.remove("isActive");
      this.overlay.classList.add("hidden");
    }

    openDrop() {
      this.content.classList.add("isActive");
      this.head.classList.add("isActive");
      this.overlay.classList.remove("hidden");
    }
  }
  customElements.define("dropdown-click", VariantSelector);
})();
